import React from 'react';
import { Link } from 'react-router-dom';
import { BaseModal } from './BaseModal';

interface PrivacyPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function PrivacyPolicyModal({ isOpen, onClose }: PrivacyPolicyModalProps) {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="Privacy Policy"
    >
      <div className="space-y-4 text-gray-600 dark:text-gray-300">
        <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-xl p-4 mb-6">
          <p className="text-yellow-800 dark:text-yellow-200 text-sm">
            This is a test website for demonstration purposes only. The information below is an example of how a privacy policy might be described.
          </p>
        </div>

        <p>
          Our Online Privacy and Security Policy lets consumers know how we collect, use, share, and protect 
          information about you. By interacting with us through our website, mobile applications, and any 
          other digital platforms, you consent to the practices described in this Privacy Policy.
        </p>

        <p>
          We are committed to protecting your privacy and ensuring the security of your personal information. 
          This policy outlines our practices regarding the collection, use, and disclosure of your information 
          across all our digital platforms and services.
        </p>

        <p>
          If you are a registered user of our services, you may have additional rights and options 
          regarding your personal information and privacy preferences.
        </p>

        <div className="mt-8">
          <Link 
            to="/privacy"
            className="text-[#5e9bb8] hover:text-[#499da8] dark:text-[#5e9bb8] dark:hover:text-[#499da8] transition-colors duration-200"
            onClick={onClose}
          >
            Read our full Online Privacy & Security Policy
          </Link>
        </div>
      </div>
    </BaseModal>
  );
}